import ManagedTable, { ManagedColumn, ManagedTableProps } from 'app/common/table/ManagedTable';
import { TrafficVolume } from 'app/model/CORE';
import React from 'react';
import { TableUtils } from 'app/common/util/TableUtils';
import KeyUtils from 'app/common/util/KeyUtils';
import useWindowDimensions from '../../common/hooks/useWindowDimensions';
import { CheckCircleFilled } from '@ant-design/icons';
import AirspaceUtils from '../../common/util/AirspaceUtils';

/* Traffic Volume Columns & Traffic Volume Table definitions */
export class TrafficVolumeColumn extends ManagedColumn<TrafficVolume> {}

export const TV_SELECTED_COLUMN = new TrafficVolumeColumn(
    '',
    '2em',
    object => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

export class StandardTrafficVolumeColumn {
    public static readonly ID = new TrafficVolumeColumn('TV ID', '8em', object => object.id);
    public static readonly REF_LOC = new TrafficVolumeColumn('REF LOC', '10em', obj =>
        AirspaceUtils.toTvRefLocationString(obj.refLocation),
    );
    public static readonly MONITORABLE = new TrafficVolumeColumn('MON', '5em', object =>
        object.monitorable ? 'Y' : null,
    );
}

export class TrafficVolumeTableBase extends ManagedTable<TrafficVolume> {
    static getUpdatedSingleSelection<T extends TrafficVolume>(selection: T, data: Array<T>) {
        return TableUtils.getUpdatedSingleSelection(selection, data, KeyUtils.TV_KEY_PROVIDER);
    }

    static getUpdatedMultipleSelection<T extends TrafficVolume>(selection: Array<T>, data: Array<T>) {
        return TableUtils.getUpdatedMultipleSelection(selection, data, KeyUtils.TV_KEY_PROVIDER);
    }
}

// I have had to adapt ManagedTable so that it accepts a font size.
// VirtualTable that is behind only accepts column width in "px", whereas our column definition is in "em".
// This usually is not a problem when font size is fixed, but in our case, font size depends on the viewport width.
// When the viewport is resized, the new font size is provided to the flight table, that will adapt column width accordingly.
const TrafficVolumeTable = (props: ManagedTableProps<TrafficVolume>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <TrafficVolumeTableBase fontSize={fontSize} {...props} />;
};

export default TrafficVolumeTable;
